var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "svg-public/img/overquota-share/error.svg__a",
  cx: 48,
  cy: 48,
  r: 48
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FF4D4A",
  cx: 48,
  cy: 48,
  r: 48
}), /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/overquota-share/error.svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-public/img/overquota-share/error.svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M99 84c3.312 0 6 2.689 6 6s-2.688 6-6 6H46c-3.311 0-6-2.689-6-6s2.688-6 6-6h53zM37.269 70c-3.864 0-7-3.137-7-7s3.136-7 7-7L57 45h-1c-4.415 0 1-6.585 1-11s3.585-8 8-8h-2c3.863 0 7-3.137 7-7s-3.137-7-7-7h-7c-3.311 0-6-2.689-6-6s2.688-6 6-6h53c3.312 0 6 2.689 6 6s-2.688 6-6 6h-4c3.863 0 7 3.137 7 7s-3.137 7-7 7h9c4.415 0 8 3.585 8 8s-3.585 8-8 8h-8l-4 14h-1c3.863 0 7 3.137 7 7s-3.137 7-7 7h-8c3.863 0 7 3.137 7 7s-3.137 7-7 7H51c3.863 0 7-3.137 7-7s-3.137-7-7-7H37.269z",
  fillOpacity: 0.773,
  fill: "#F73532",
  mask: "url(#svg-public/img/overquota-share/error.svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.04 74.274a33.245 33.245 0 0 1-7.205-7.542M19.415 31.51c4.545-7.856 12.235-13.669 21.343-15.712",
  strokeOpacity: 0.1,
  stroke: "#FFF",
  strokeWidth: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.268 38.803a5.003 5.003 0 0 0 0-7.071 5.003 5.003 0 0 0-7.071 0L31.732 57.197a5.003 5.003 0 0 0 0 7.071 5.003 5.003 0 0 0 7.071 0l25.465-25.465z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.732 38.803a5.003 5.003 0 0 1 0-7.071 5.003 5.003 0 0 1 7.071 0l25.465 25.465a5.003 5.003 0 0 1 0 7.071 5.003 5.003 0 0 1-7.071 0L31.732 38.803z",
  fill: "#FFF"
}))));
export { SvgError as ReactComponent };